module.exports = __webpack_public_path__ + "web/img/verify10.8f9140b4.jpg";